/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import { Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { throttle as _throttle } from 'lodash';
import { Waypoint } from 'react-waypoint';
import { MESSAGES_COUNT_PER_PAGE } from 'Constants/webchat';
import * as Actions from 'Redux/modules/webChat/actions';
import { getMessages, getMessageByConsult } from 'Selectors/webChat/messages';
import { getConsultById } from 'Selectors/webChat/consults';

import MessageList from './MessageList/MessageList';
import Uploading from './Uploading/Uploading';

const sortComparator = (item1, item2) => {
  if (item1.sentAt > item2.sentAt) return 1;
  if (item1.sentAt < item2.sentAt) return -1;
  return 0;
};

class MessageBodyPatient extends PureComponent {
  offset = 0;

  loadingUser = false;

  constructor(props) {
    super(props);
    this.handleScroll = _throttle(this.handleScroll, 100);
  }

  componentDidMount() {
    const { isMinimize, conversationActive } = this.props;
    const groupId = conversationActive?.id;
    const body = document.getElementById(isMinimize ? `message_body_${groupId}` : 'message_body');
    body.addEventListener('scroll', this.handleScroll);
    body.scrollTop = body.scrollHeight;
  }

  componentDidUpdate(prevProps) {
    const {
      messages,
      conversationActiveId,
      users,
      invitation: { status: statusInvitation },
      isMinimize,
      conversationActive,
    } = this.props;
    const groupId = conversationActive?.id;
    if (prevProps.conversationActiveId !== conversationActiveId) this.offset = 0;
    const { messageIdByTime, status } = messages;
    if (messageIdByTime !== prevProps.messages.messageIdByTime) {
      const view = document.getElementById(messageIdByTime);
      if (view) {
        view.scrollIntoView({ block: 'center' });
      }
    } else if (
      conversationActiveId === groupId &&
      prevProps.messages.status.loadingBackward === 0 &&
      status.loadingBackward === 1
    ) {
      const body = document.getElementById(isMinimize ? `message_body_${groupId}` : 'message_body');
      body.scrollTop = body.scrollHeight - this.offset;
    }
    if (
      prevProps.users.status.loadUser === 0 &&
      (users.status.loadUser === 1 || users.status.loadUser === 2)
    ) {
      this.loadingUser = false;
    }
    if (prevProps.invitation.status.accept === 0 && statusInvitation.accept === 1) {
      this.getMessageByTime();
    }
  }

  componentWillUnmount() {
    const { isMinimize, conversationActive } = this.props;
    const groupId = conversationActive?.id;
    const body = document.getElementById(isMinimize ? `message_body_${groupId}` : 'message_body');
    body.scrollTop = body.scrollHeight - this.offset;
    body.removeEventListener('scroll', this.handleScroll);
  }

  getMessageByTime = () => {
    const { conversationActiveId, getMessagesBackwardByTime } = this.props;
    if (conversationActiveId) {
      getMessagesBackwardByTime({
        conversationId: conversationActiveId,
        count: MESSAGES_COUNT_PER_PAGE,
        timestamp: Date.now(),
      });
    }
  };

  handleScroll = e => {
    const body = e.target;
    const newOffset = body.scrollHeight - body.scrollTop;
    this.offset = newOffset;
  };

  getMoreBackwardMessages = () => {
    const { isMinimize, conversationActive } = this.props;
    const groupId = conversationActive?.id;
    const body = document.getElementById(isMinimize ? `message_body_${groupId}` : 'message_body');
    const newOffset = body.scrollHeight - body.scrollTop;
    this.offset = newOffset;

    const { getMessagesBackwardByTime, messages, listMessages } = this.props;
    const {
      status,
      meta: { isLoadMoreBackward },
    } = messages;
    const time = listMessages[0]?.sentAt;
    if (status.loadingBackward !== 0 && isLoadMoreBackward && conversationActive?.id) {
      getMessagesBackwardByTime({
        timestamp: time,
        conversationId: conversationActive.id,
        count: 20,
      });
    }
  };

  getMoreForwardMessages = () => {
    const { conversationActiveId, isMinimize } = this.props;
    const body = document.getElementById(
      isMinimize ? `message_body_${conversationActiveId}` : 'message_body',
    );
    const newOffset = -body.scrollHeight + body.scrollTop;
    this.offset = newOffset;

    const { getMessagesForwardByTime, messages, conversationActive, listMessages } = this.props;
    const {
      status,
      meta: { isLoadMoreForward },
    } = messages;
    const time = listMessages[listMessages.length - 1].sentAt;
    if (status.loadingForward !== 0 && isLoadMoreForward && conversationActive.id) {
      getMessagesForwardByTime({
        timestamp: time,
        conversationId: conversationActive.id,
        count: 20,
      });
    }
  };

  findOtherUser = uuid => {
    const {
      conversationActive,
      users: { users, status },
      pendingConsultActive,
      getConsultByIdAct,
    } = this.props;
    const { latestConsult } = conversationActive || { latestConsult: null };
    let patient = latestConsult?.patient;
    const doctors = latestConsult?.doctors || [];

    let avatarUrl = '';
    let fullName = '';
    let found = false;
    if (!pendingConsultActive) {
      patient = getConsultByIdAct(pendingConsultActive)?.patient;
    }
    if (patient?.userUuid === uuid || uuid === 'bot') {
      avatarUrl = patient?.avatarUrl;
      fullName = patient?.fullName;
      found = true;
    } else if (doctors.length > 1) {
      // case other invited doctor chat
      const doctor = doctors.find(_doctor => _doctor.userUuid === uuid);
      avatarUrl = doctor?.avatarUrl;
      fullName = doctor?.fullName;
      found = true;
    }

    if (!found) {
      // get avatar from reducer
      const currentUser = users[uuid];
      if (currentUser) {
        avatarUrl = currentUser?.avatarUrl;
        fullName = currentUser?.fullName;
      } else if (status.loadUser !== 0 && !this.loadingUser) {
        this.loadingUser = true;
        // getUserInfo(id);
      }
    }
    return {
      avatarUrl,
      fullName,
    };
  };

  render() {
    const {
      conversationActive,
      acceptConsult,
      messages,
      listMessages,
      doctor,
      openMedicalCertificate,
      isGettingConsultGroup,
      isMinimize,
      uploadGroup,
      onSetReply,
      pendingConsultActive,
      getConsultByIdAct,
      listPendingMessages,
    } = this.props;
    const groupId = conversationActive?.id;
    const channelUuid = conversationActive?.latestConsult?.channel?.uuid || null;
    const {
      meta: { isLoadMoreBackward, isLoadMoreForward },
      status: { loadingBackward, loadingForward, loadingInvitation, loadingPool },
    } = messages;

    const isLoading =
      (loadingBackward === 0 ||
        loadingForward === 0 ||
        loadingInvitation === 0 ||
        loadingPool === 0 ||
        isGettingConsultGroup) &&
      listMessages.length === 0;
    if (isLoading) {
      this.offset = 0;
      return (
        <Segment
          className="message-body"
          id={isMinimize ? `message_body_${groupId}` : 'message_body'}
          loading={isLoading}
          basic
        />
      );
    }

    const pendingConsult = getConsultByIdAct(pendingConsultActive);

    const patient = conversationActive?.patient || pendingConsult?.patient;
    return (
      <>
        {channelUuid === uploadGroup && <Uploading />}
        <div className="message-body" id={isMinimize ? `message_body_${groupId}` : 'message_body'}>
          {isLoadMoreBackward && (
            <Waypoint onEnter={this.getMoreBackwardMessages}>
              <div className="text-center">Loading...</div>
            </Waypoint>
          )}
          <MessageList
            conversation={conversationActive}
            list={pendingConsultActive !== -1 && !isMinimize ? listPendingMessages : listMessages}
            messages={messages}
            doctor={doctor}
            acceptConsult={acceptConsult}
            openMedicalCertificate={openMedicalCertificate}
            otherUser={pendingConsult?.patient || patient}
            findOtherUser={this.findOtherUser}
            handleLoadMore={this.getMoreBackwardMessages}
            onSetReply={onSetReply}
            pendingConsultActive={pendingConsultActive}
          />
          {isLoadMoreForward && (
            <Waypoint onEnter={this.getMoreForwardMessages}>
              <div className="text-center">Loading...</div>
            </Waypoint>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  listMessages: getMessages(
    state,
    props.conversationActive?.latestConsult?.id,
    props.conversationActive?.id,
  ).sort(sortComparator),
  listPendingMessages: getMessageByConsult(state, props.pendingConsultActive).sort(sortComparator),
  messages: state.webChat.messages,
  consults: state.webChat.consults,
  users: state.webChat.users,
  getConsultByIdAct: id => getConsultById(state, id),
  invitation: state.webChat.invitation,
  uploadGroup: state.webChat.commons.uploadGroup,
  isGettingConsultGroup: state.webChat.conversation.status.loadDetails === 0,
});

const mapDispatchToProps = {
  acceptConsult: Actions.consultAccepted,
  getMessagesBackwardByTime: Actions.getMessagesBackwardByTime,
  getMessagesForwardByTime: Actions.getMessagesForwardByTime,
  getUserInfo: Actions.getUserInfo,
  acceptConsultPending: Actions.acceptConsultPending,
  resetConsultStatus: Actions.resetConsultStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageBodyPatient);
